export default __webpack_public_path__ + "static/media/newsNurses.cf26ac0e.png";